/* Tiny, safe markdown renderer (ported from the original prototype lib.jsx). */

function escapeHtml(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function renderInline(s) {
  s = escapeHtml(s);
  s = s.replace(/`([^`]+)`/g, (_, c) => `<code>${c}</code>`);
  s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/(^|[^*])\*([^*]+)\*/g, "$1<em>$2</em>");
  return s;
}

export function renderMarkdown(text) {
  if (!text) return "";
  const out = [];
  const parts = text.split(/```/);
  parts.forEach((chunk, i) => {
    if (i % 2 === 1) {
      const nl = chunk.indexOf("\n");
      const code = nl >= 0 ? chunk.slice(nl + 1) : chunk;
      out.push(`<pre><code>${escapeHtml(code.replace(/\n$/, ""))}</code></pre>`);
      return;
    }
    const lines = chunk.split("\n");
    let listType = null;
    let buf = [];
    const flush = () => { if (buf.length) { out.push(`<p>${buf.join("<br/>")}</p>`); buf = []; } };
    const closeList = () => { if (listType) { out.push(`</${listType}>`); listType = null; } };
    for (const line of lines) {
      const h = line.match(/^(#{1,3})\s+(.*)/);
      const ul = line.match(/^\s*[-*]\s+(.*)/);
      const ol = line.match(/^\s*\d+\.\s+(.*)/);
      if (h) { flush(); closeList(); out.push(`<h3>${renderInline(h[2])}</h3>`); }
      else if (ul) { flush(); if (listType !== "ul") { closeList(); out.push("<ul>"); listType = "ul"; } out.push(`<li>${renderInline(ul[1])}</li>`); }
      else if (ol) { flush(); if (listType !== "ol") { closeList(); out.push("<ol>"); listType = "ol"; } out.push(`<li>${renderInline(ol[1])}</li>`); }
      else if (line.trim() === "") { flush(); closeList(); }
      else { closeList(); buf.push(renderInline(line)); }
    }
    flush(); closeList();
  });
  return out.join("");
}
